import React from 'react';
import { Typography, Button, Card, CardContent } from '@mui/material';
import BarChartIcon from '@mui/icons-material/BarChart';
import ErrorBoundary from './ErrorBoundary';

const ChartFallback = ({ error, onRetry }) => (
  <Card sx={{ height: 420 }}>
    <CardContent sx={{ 
      height: '100%', 
      display: 'flex', 
      flexDirection: 'column', 
      justifyContent: 'center', 
      alignItems: 'center',
      textAlign: 'center'
    }}>
      <BarChartIcon sx={{ fontSize: 48, color: '#d63031', marginBottom: 2 }} />
      <Typography variant="h6" sx={{ marginBottom: 1, color: '#a52b22' }}>
        Chart Error
      </Typography>
      <Typography variant="body2" sx={{ marginBottom: 2, color: '#6c757d' }}>
        Unable to display chart data
      </Typography>
      <Button 
        size="small"
        variant="outlined" 
        onClick={onRetry}
        sx={{ borderColor: 'var(--color-brand)', color: 'var(--color-brand)' }}
      >
        Retry
      </Button>
    </CardContent>
  </Card>
);

const ChartErrorBoundary = ({ children }) => {
  return (
    <ErrorBoundary fallback={ChartFallback}>
      {children}
    </ErrorBoundary>
  );
};

export default ChartErrorBoundary;
